export const esCommon = {
  'common.administration': 'Administración',
  'common.back': 'Volver',
  'common.backHome': 'Volver a Inicio',
  'common.cancel': 'Cancelar',
  'common.close': 'Cerrar',
  'common.demoDescription': 'Datos simulados · no usa producción ni credenciales reales.',
  'common.demoMode': 'Vista local',
  'common.loadingAccount': 'Cargando cuenta',
  'common.loadingAdmin': 'Cargando administración',
  'common.loadingAdviser': 'Cargando Adviser',
  'common.loadingBanks': 'Cargando bancos',
  'common.loadingDashboard': 'Cargando dashboard',
  'common.loadingNotifications': 'Cargando notificaciones',
  'common.loadingPlans': 'Cargando planes',
  'common.loadingSupport': 'Cargando soporte',
  'common.optional': '(opcional)',
  'common.retry': 'Reintentar',
  'common.save': 'Guardar',
  'common.saving': 'Guardando…',
  'common.skipContent': 'Saltar al contenido',
  'common.unavailable': 'no disponible',
} as const;

export const enCommon: Record<keyof typeof esCommon, string> = {
  'common.administration': 'Administration',
  'common.back': 'Back',
  'common.backHome': 'Back to Home',
  'common.cancel': 'Cancel',
  'common.close': 'Close',
  'common.demoDescription': 'Simulated data · no production services or real credentials.',
  'common.demoMode': 'Local preview',
  'common.loadingAccount': 'Loading account',
  'common.loadingAdmin': 'Loading administration',
  'common.loadingAdviser': 'Loading Adviser',
  'common.loadingBanks': 'Loading banks',
  'common.loadingDashboard': 'Loading dashboard',
  'common.loadingNotifications': 'Loading notifications',
  'common.loadingPlans': 'Loading plans',
  'common.loadingSupport': 'Loading support',
  'common.optional': '(optional)',
  'common.retry': 'Try again',
  'common.save': 'Save',
  'common.saving': 'Saving…',
  'common.skipContent': 'Skip to content',
  'common.unavailable': 'unavailable',
};
